import { render, staticRenderFns } from "./MotionsModal.vue?vue&type=template&id=4fb6a726&scoped=true&"
import script from "./MotionsModal.vue?vue&type=script&lang=js&"
export * from "./MotionsModal.vue?vue&type=script&lang=js&"
import style0 from "./MotionsModal.vue?vue&type=style&index=0&id=4fb6a726&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb6a726",
  null
  
)

export default component.exports